import { primaryBlue, red } from '../../styles/material-ui-theme-v2'
import { Tooltip } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

const YumTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: primaryBlue,
  },
  arrow: {
    color: primaryBlue,
  },
}))(Tooltip)

export const YumDangerTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: red,
  },
  arrow: {
    color: red,
  },
}))(Tooltip)

export default YumTooltip
